import React, { useState, useEffect } from 'react'
import { Grid, GridItem } from '@deal/components'
import PageContent from '#src/app/components/PageContent'
import styles from './styles.css'

const HeaderTextAnimation: React.FunctionComponent<{ headerTextArr?: string[] }> = ({
  headerTextArr = ['Shop with an expert.', 'Love what you buy.']
}) => {
  return (
    <>
      {headerTextArr.map((text, index) => {
        return <div key={index}>{text}</div>
      })}
    </>
  )
}

interface LandingHeaderTextProps {
  actions: React.ReactNode
  headerTextArr?: string[]
}

const LandingHeaderText: React.FunctionComponent<LandingHeaderTextProps> = ({
  actions,
  headerTextArr
}) => {
  const [hasComponentMounted, setHasComponentMounted] = useState(false)
  useEffect(() => {
    setHasComponentMounted(true)
  }, [])

  return (
    <>
      <PageContent>
        <div className={styles.headerText}>
          {hasComponentMounted && <HeaderTextAnimation headerTextArr={headerTextArr} />}
        </div>
      </PageContent>
      <Grid className={styles.actions}>
        <GridItem col={2} mdCol={3} />
        <GridItem col={2} mdCol={6}>
          {actions}
        </GridItem>
        <GridItem col={2} mdCol={3} />
      </Grid>
    </>
  )
}

export default LandingHeaderText
